import { render, staticRenderFns } from "./CBodyStatus.vue?vue&type=template&id=3e4e60b2&"
import script from "./CBodyStatus.vue?vue&type=script&lang=ts&"
export * from "./CBodyStatus.vue?vue&type=script&lang=ts&"
import style0 from "./CBodyStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports